import { gql } from "graphql-request";
import { z } from "zod";
import {
  CommunityCreatorSchema,
  CommunityCreatorFragment,
} from "./communityCreator";
import { ImageSchema, ImageFragment } from "./image";
import { SysSchema, SysFragment } from "./sys";
import { Locale } from "../../locale";

export const CommunityLivestreamEntrySchema = z.object({
  sys: SysSchema,

  livestreamCreator: CommunityCreatorSchema.nullable(),

  livestreamEntryTitle: z.string().nullable(),
  livestreamEntryVideoUrl: z.string().nullable(),
  livestreamEntryVideoLocale: Locale.nullable(),
  livestreamEntrySubmissionInfo: z.string().nullable(),
  livestreamEntryVideoThumbnail: ImageSchema.nullable(),
  livestreamEntryVideoThumbnailEn: ImageSchema.nullable(),
  livestreamEntryStartDate: z.string().nullable(),
  livestreamEntryEndDate: z.string().nullable(),
});

export const CommunityLivestreamEntry = CommunityLivestreamEntrySchema;
export type CommunityLivestreamEntry = z.infer<
  typeof CommunityLivestreamEntrySchema
>;

export const CommunityLivestreamEntryFragment = gql`
  fragment CommunityLivestreamEntryFragment on CommunityLivestreamEntry {
    sys {
      ...SysFragment
    }
    livestreamEntryTitle
    livestreamEntryVideoUrl
    livestreamEntryVideoLocale
    livestreamEntrySubmissionInfo
    livestreamEntryStartDate
    livestreamEntryEndDate
    livestreamEntryVideoThumbnail {
      ...ImageFragment
    }
    livestreamEntryVideoThumbnailEn: livestreamEntryVideoThumbnail(
      locale: "en"
    ) {
      ...ImageFragment
    }
    livestreamCreator {
      ...CommunityCreatorFragment
    }
  }

  ${CommunityCreatorFragment}
  ${ImageFragment}
  ${SysFragment}
`;
